export enum InsuranceCategories {
	FLEXIBLE_INSTALLMENTS_INSURANCES = "FLEXIBLE_INSTALLMENTS_INSURANCES",
	FULL_PRICE_INSURANCES = "FULL_PRICE_INSURANCES",
}
